var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProgressFutureIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B7B9BD",
    fillRule: "evenodd",
    d: "M5.3334 12c0-3.6819 2.9848-6.6666 6.6667-6.6666S18.6667 8.318 18.6667 12s-2.9847 6.6667-6.6666 6.6667c-3.682 0-6.6667-2.9848-6.6667-6.6667m10 0c0-1.8409-1.4924-3.3333-3.3333-3.3333S8.6668 10.1591 8.6668 12 10.159 15.3334 12 15.3334 15.3334 13.841 15.3334 12",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProgressFutureIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/progress-future-icon.fec49f2d744c019abe3f9f28f4b32a2b.svg";